import Xhr from '../../core/xhr'

export default {
  namespaced: true,
  state: {
    loading: false,
    form: new Xhr({
      locale: 'de',
      user: {
        vorname: '',
        nachname: '',
        email: '',
        phone: '',
        company: '',
        position: '',
        gdprnews: '',
        gdprstorno: '',
        gdprdaten: ''
      },
      options: {
        package: null,
        tagen: [],
        shuttle: null,
        childcare: null,
        camping: null,
        culturePass: null,
        nutrition: ''
      }
    }),
    course: {
      id: null,
      title: null
    },
    termine: {
      duration: '',
      days: []
    }
  },
  mutations: {
    user (state, user) {
      state.form.user = user
    },
    options (state, options) {
      state.form.options = options
    },
    loading (state, loading) {
      state.loading = loading
    },
    course (state, { id, title }) {
      state.course.id = id
      state.course.title = title
    },
    termine (state, termine) {
      state.termine = termine
    }
  },
  actions: {
    updateUser ({ commit }, { user }) {
      commit('user', user)
    },
    updateOptions ({ commit }, { options }) {
      commit('options', options)
    },
    async fetchCourse ({ commit, rootState }) {
      try {
        var response = await new Xhr().get(`${rootState.url}/simple-form/course`)
        commit('course', { id: response.id, title: response.title })
        commit('termine', response.termine)
      } catch (error) {
        console.log(error)
      }
      return response || { success: false }
    },
    async fetchTermine ({ commit, rootState }) {
      try {
        var response = await new Xhr().get(`${rootState.url}/simple-form/termine`)
        commit('termine', response)
      } catch (error) {
        console.log(error)
      }
      return response || { success: false }
    },
    async sendForm ({ commit, state, rootState }) {
      commit('loading', true)
      try {
        var response = await state.form.post(`${rootState.url}/simple-form/store`)
      } catch (error) {
        console.log(error)
      }
      commit('loading', false)
      return response || { success: false }
    }
  },
  getters: {
    showAdditionalFields: state => state.form.options.package === '1'
  }
}
